import { createAlert } from '@compono/ui';

interface CreateToastParams {
  title: string;
  message: string;
}

export const createErrorToast = ({ title, message }: CreateToastParams) =>
  createAlert({
    tone: 'critical',
    title,
    content: message,
    position: 'top-center',
    duration: 3000,
  });

export const createSuccessToast = ({ title, message }: CreateToastParams) =>
  createAlert({
    tone: 'success',
    title,
    content: message,
    position: 'top-center',
    duration: 3000,
  });
